import React from 'react';
import Link from 'next/link';
import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import AppRoutes from '@/const/routes';

interface Props {
	caseId: string;
}

export const RetainerHeader: React.FC<Props> = ({ caseId }) => {
	const prevHref = `${AppRoutes.LAWYERAPP_CASES}/${caseId}?tab=case-administration&step=retainer`;
	return (
		<div className="py-8 px-[5.25rem] bg-white flex items-center justify-between">
			<div className="flex items-center gap-4">
				<Link href={prevHref}>
					<Icon src={Icons.arrowLeft} className="!size-6" />
				</Link>
				<Typography type="semibold-18">Back</Typography>
			</div>
			<div>
				<Typography type="semibold-16" className="opacity-60">
					This is your preview page. Select &apos;Edit&apos; to make changes or
					&apos;Approve&apos; to stage it for going live.
				</Typography>
			</div>
			<div className="flex items-center gap-6">
				<Button href={prevHref} decoration="secondary" size="medium">
					Edit
				</Button>
				<Button href={prevHref} decoration="primary" size="medium">
					Approve
				</Button>
			</div>
		</div>
	);
};
